import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

export default function getRdeDns(): string | undefined {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return (globalThis as GlobalThisWithLocalDevContext).localDevContext?.RDE_DNS;
}
